import React, { useState } from 'react';
import { View } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { Text } from '../../../globalComponents/NativeOverrides';
import { MetricsComponent } from '../../../objectTypes';
import { AnalyticBarChart, AnalyticPieChart, AnalyticProgressChart } from './AnalyticCharts';
import { PublicPlayerProps } from '../../../store/types/auth_svc';

type AnalyticChartCardProps = { metric: MetricsComponent, width:number }

const MAX_WIDTH = 400

const AnalyticChartCard = ({ metric, width } : AnalyticChartCardProps) => {
    const [ chartCardSize, setChartCardSize ] = useState({ x: 0, y:0, width:0, height:0 })
    
    const renderChart = () => {
        switch(metric.chart_type){
            case 'progress_chart': return (
                <AnalyticProgressChart width={chartCardSize.width} chart_data={metric.chart_data}/>
                )
            case 'pie_chart': return (
                <View style={{width:chartCardSize.width, height:chartCardSize.width*0.8, justifyContent:'center', alignItems:'center'}}>
                    <AnalyticPieChart width={chartCardSize.width * 0.7} data={metric.chart_data}/>
                </View>
            )
            case 'bar_chart':
                return (
                    <View style={{width:chartCardSize.width, height:chartCardSize.width*0.8, justifyContent:'center', alignItems:'center'}}>
                        <AnalyticBarChart width={chartCardSize.width * 0.7} chart_data={metric.chart_data}/>
                    </View>
                )
            default: return <></>
        }
    }
    
    
    return (
        <View style={{ margin:10, backgroundColor:Colors.shades.shade200, borderRadius:8, padding:20}}>
            <View onLayout={(ev) => {
                const { x, y, width, height } = ev.nativeEvent.layout
                setChartCardSize({ x, y, width: width < MAX_WIDTH ? width : MAX_WIDTH, height })
            }}>
                <Text size={16} color={Colors.brand.midnight} weight='semibold'>{metric.metric_name}</Text>
                <View style={{ justifyContent:'center', alignItems:'center', marginTop:20 }}>
                    {renderChart()}
                </View>
            </View>
        </View>
    )
}

export default AnalyticChartCard